const TZ = "Africa/Abidjan";

export function fcfa(n) {
  const v = Number.isFinite(Number(n)) ? Math.round(Number(n)) : 0;
  return `${String(v).replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA`;
}

export function fdate(d) {
  if (!d) return "—";
  return new Intl.DateTimeFormat("fr-FR", { timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric" }).format(new Date(d));
}

export function fdatetime(d) {
  if (!d) return "—";
  const date = new Date(d);
  const time = new Intl.DateTimeFormat("fr-FR", { timeZone: TZ, hour: "2-digit", minute: "2-digit" }).format(date);
  return `${fdate(date)} ${time}`;
}

export function ftime(d) {
  return new Intl.DateTimeFormat("fr-FR", { timeZone: TZ, hour: "2-digit", minute: "2-digit" }).format(new Date(d));
}

export function fphone(p = "") {
  const m = p.match(/^\+225(\d{10})$/);
  return m ? m[1].replace(/(\d{2})(?=\d)/g, "$1 ") : p;
}

export function initials(name = "") {
  return name.split(" ").filter(Boolean).slice(0, 2).map((p) => p[0]).join("").toUpperCase();
}
